import { render, staticRenderFns } from "./queryComponent.vue?vue&type=template&id=2449b723&scoped=true"
import script from "./queryComponent.vue?vue&type=script&lang=js"
export * from "./queryComponent.vue?vue&type=script&lang=js"
import style0 from "./queryComponent.vue?vue&type=style&index=0&id=2449b723&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449b723",
  null
  
)

export default component.exports